
import Vue from "vue";
import { VLayout } from "vuetify/lib";
import { APPLICATION } from "@/store/applications";
import { mapGetters } from "vuex";
import { ROUTE_NAMES } from "@/routes";
import { IRootState } from "@/store/types";
import store from "@/store";

export default Vue.extend();
